var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ArcBaseService } from './arc-base.service';
import { LoadingService } from './loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { loadModules } from 'esri-loader';
var LandOwnershipLU = /** @class */ (function () {
    function LandOwnershipLU() {
    }
    return LandOwnershipLU;
}());
export { LandOwnershipLU };
var LandOwnershipLuService = /** @class */ (function (_super) {
    __extends(LandOwnershipLuService, _super);
    function LandOwnershipLuService(snackBar, loadingService) {
        return _super.call(this, '10', snackBar, loadingService) || this;
    }
    LandOwnershipLuService.prototype.create_new_action = function (project_fk, actions) {
        var vm = this;
        // const project = new Project();
        var config = new ConfigService();
        return new Observable(function (obs) {
            vm.layerIsLoaded.subscribe(function () {
                loadModules(['esri/graphic', 'esri/geometry/Polygon', 'esri/SpatialReference'], config.jsapi_config).then(function (_a) {
                    var Graphic = _a[0], Polygon = _a[1], SpatialReference = _a[2];
                    var landOwnership = new Graphic(vm.layer.templates[0].prototype.toJson());
                    // project.setSymbol(vm.layer.renderer.getSymbol());
                    // project.setGeometry(new Polygon(new SpatialReference(3857)));
                    landOwnership.attributes.GlobalID = 'new';
                    landOwnership.attributes.project_fk = project_fk;
                    landOwnership.attributes.Land_Ownership = actions;
                    vm.addFeature(landOwnership, true).subscribe();
                    obs.next(landOwnership);
                    obs.complete();
                });
            });
        });
    };
    return LandOwnershipLuService;
}(ArcBaseService));
export { LandOwnershipLuService };
